var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "mb-32 d-flex flex-wrap w-100" }, [
          _c("h3", {
            staticClass: "title",
            domProps: { innerHTML: _vm._s(_vm.title) }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row row-xs-small mb-md-n24" },
          _vm._l(_vm.categories, function(category, index) {
            return _c(
              "div",
              { key: index, staticClass: "col-4 col-md-3 col-xl-2" },
              [
                _c(
                  "a",
                  {
                    staticClass: "filter mb-md-24",
                    attrs: {
                      href: _vm.route("nl.activities", {
                        categories: category.slug
                      })
                    }
                  },
                  [
                    _c("p", {
                      staticClass: "small",
                      domProps: { innerHTML: _vm._s(category.name) }
                    })
                  ]
                )
              ]
            )
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }